import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const Tennis = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Tennis',
    category: 'Racket Sports',
    description: 'Professional tennis courts with coaching programs.',
    longDescription: 'Love tennis? Join our vibrant Tennis Club with professional courts, expert coaching, and a thriving social scene. From beginner lessons to competitive leagues, we offer programs for all ages and skill levels. Our community of tennis enthusiasts enjoys regular social play, tournaments, and club events.',
    images: [
      getImagePath('images/bars/tennis.jpg'),
      getImagePath('images/bars/tennis.jpg'),
      getImagePath('images/bars/tennis.jpg')
    ],
    icon: 'fa-table-tennis',
    members: '55+ active members',
    coach: 'ATP Certified Coach David Nnamdi',
    schedule: 'Daily: 6am - 9pm',
    level: 'All Levels',
    features: [
      'Professional Courts',
      'Night Lighting',
      'Ball Machine',
      'Private Lessons',
      'Group Clinics',
      'Junior Development',
      'Adult Leagues',
      'Social Mixers'
    ],
    facilities: ['Hard Courts', 'Clay Courts', 'Pro Shop', 'Viewing Deck'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'tennis@nlngraclub.com',
      extension: '215'
    },
    programs: ['QuickStart Tennis (Kids)', 'Junior Academy', 'Adult Clinics', 'High Performance'],
    events: ['Club Championships', 'Box Leagues', 'Social Tennis', 'Inter-club Matches']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Head Pro</h4>
                    <p>{sectionData.coach}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Hours</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Programs:</span>
                  <span className="info-value">{sectionData.programs.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Events:</span>
                  <span className="info-value">{sectionData.events.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/reservation" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Book a Court
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tennis;